// src/components/Hero/Hero.js
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import './Hero.css';
import { HERO_TITLE, HERO_DESCRIPTION, CALL_TO_ACTION_TEXT, SECTION_IDS } from '../../constants';
import digitalExperiencesImg from '../../assets/digitalExperiences.png';

const Hero = ({ scrollToSection }) => {
  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

  return (
    <section className="hero" id="hero">
      <div className={`hero-content ${isDesktop ? 'desktop' : 'mobile'}`}>
        <div className="hero-text-content">
          <h1>{HERO_TITLE}</h1>
          <p>{HERO_DESCRIPTION}</p>
          <button
            onClick={() => scrollToSection(SECTION_IDS.CONTACT)}
            className="hero-cta-button"
          >
            {CALL_TO_ACTION_TEXT}
          </button>
        </div>
        {isDesktop && (
          <div className="hero-image-content">
            <img src={digitalExperiencesImg} alt="Digital Experiences" className="hero-image" />
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
